module.exports = __webpack_public_path__ + "static/media/OnBoarding_Texture_Logo.ee8c651d.png";